import { StandardEvents } from '@shopify/events';

/**
 * Keeps the custom ITI AVA header cart badge synchronized with Shopify's AJAX cart.
 * The main Horizon header-actions component already listens to the standard cart event,
 * but the custom ITI AVA header previously rendered cart.item_count only once on page load.
 */
(() => {
  const SELECTOR = '.ita-header__cart-count';
  let refreshTimer;

  const getBadges = () => document.querySelectorAll(SELECTOR);

  const render = (count) => {
    const value = Math.max(0, Number(count) || 0);
    getBadges().forEach((badge) => {
      badge.textContent = String(value);
      badge.setAttribute('data-count', String(value));
      badge.hidden = false;
    });
  };

  const refreshFromAjaxCart = async () => {
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });

      if (!response.ok) return;

      const cart = await response.json();
      render(cart?.item_count ?? 0);
    } catch (_) {
      // Keep the server-rendered value if the network refresh fails.
    }
  };

  const scheduleRefresh = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshFromAjaxCart, 0);
  };

  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    event.promise
      ?.then(({ cart, detail }) => {
        render(cart?.totalQuantity ?? detail?.itemCount ?? 0);
      })
      .catch(() => {
        scheduleRefresh();
      });
  });

  window.addEventListener('pageshow', scheduleRefresh);
  window.addEventListener('focus', scheduleRefresh);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') scheduleRefresh();
  });

  // Initial state: confirm the server-rendered badge against /cart.js.
  scheduleRefresh();
})();
